import React, { useEffect, useState } from 'react'
import general from '../../../../general'
import './css/Announcement.css'
import { Popup } from 'antd-mobile'
import { CSSTransition } from 'react-transition-group'
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment'
import { NavLink } from '../../../../lib/Navigation'
import URI from 'urijs'
export default function Announcement(props) {

  const [list,setList] = useState([])
  const [item,setItem] = useState()
  const [alert,setAlert] = useState(false)

  useEffect(()=>{
    getClusterInfo()
  },[])

  useEffect(()=>{
    if (alert){
      readAnnoument()
    }
  },[alert])

  const getClusterInfo = ()=>{
    general.axios.post('/base/yunxin/getClusterInfo',{tid:props.query.tid})
    .then(res=>{
      const { data, status } = res.data
      if (status.succeed){
        setList(data.info.announcement.list)
        if (props.query.open){
          setItem(data.info.announcement.list[0])
          setAlert(true)
        }
      }else{
        Dialog.error(status.error_desc)
      }
    })
  }

  const readAnnoument = ()=>{
    general.axios.post('/base/yunxin/readAnnoument',{id:item.id})
    .then(res=>{
      const { data, status } = res.data
      if (status.succeed) {
        item.is_read = true
      }else{
        Dialog.error(status.error_desc)
      }
    })
  }

  return (
    <div className='announcement-index'>
    {list.map((item,idx)=>{
      return <div className="item" key={idx} onClick={()=>{
        setItem(item)
        setAlert(true)
      }}>
        <div className="header">
          <span className="tag" style={{display:item.is_top ? '' : 'none'}}></span>
          <span className="title">{item.title}</span>
          <div className='point' style={{display:item.is_read ? 'none' : ''}}></div>
        </div>
        <div className="content" style={{maxHeight:'67px',fontSize:13}} dangerouslySetInnerHTML={{__html: item.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')}}></div>
        <div className="time">{moment(item.time*1000).format('YYYY-MM-DD HH:mm:ss')}</div>
      </div>
    })}
    <Popup
      visible={alert}
      onMaskClick={() => setAlert(false)}
      position="bottom"
      bodyStyle={{
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        maxHeight: '65vh',
        overflow: 'scroll',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className="announcement-container">
        <div className="announcement-top">
          <div className="title"></div>
          <CloseOutlined className='close' onClick={() => setAlert(false)} />
        </div>
        <div className="announcement-main">
          <div className="title">{item?.title}</div>
          <div className="desc" dangerouslySetInnerHTML={{__html: item?.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')}}></div>
          <div className="time">{item ? moment(item.time*1000).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          {parseInt(item?.type) == 1 && <NavLink to={(()=>{
            const genre_value = item?.genre_value
            let url = URI(genre_value)
                        .addQuery('title', item?.title)
                        .addQuery('topic_id', item?.topic_id)
                        .addQuery('username', localStorage.getItem('username'))
                        .toString();
                      return url;
          })()} iframe={{title:item?.title}} className='btn' onClick={()=>{setAlert(false)}}>前往查看</NavLink>}
        </div>
      </div>
    </Popup>
    </div>
  )
}
